/*eslint-disable*/
import settings from "../../../configs/settings";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Add } from "@mui/icons-material";
import CancelIcon from "@mui/icons-material/Cancel";
import SavedSearchIcon from "@mui/icons-material/SavedSearch";
import { Box } from "@mui/system";
import { useState, useEffect, useContext } from "react";
import GestionAtencionContext from "../../../project/contexts/GestionAtencionContext";
import { getPorcentajeDescuento } from "../../../project/services/ArticuloService";
import { getCacheData } from "../../services/CacheService";
import BuscarLPLenteContactoDialog from "./BuscarLPLenteContactoDialog";
import LenteContactoTable from "./LenteContactoTable";
import Message from "../../../project/utils/Message";
import { isEmptyObject } from "../../../project/utils/utils";
//
// ################################################################################
//
const LenteContacto = () => {
  const [openDialogBuscarLPLenteContacto, setOpenDialogBuscarLPLenteContacto] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);

  const {
    expandedAccordionLenteContacto,
    setExpandedAccordionLenteContacto,
    disabledAccordionLenteContacto,
    lenteContactoOjoOptions,
    lenteContactoAction,
    lenteContacto,
    setLenteContacto,
    handleChangeLenteContacto,
    disabledDatosLenteContacto,
    setDisabledDatosLenteContacto,
    guardarLenteContacto,
    limpiaLenteContacto,
    gaAction,
  } = useContext(GestionAtencionContext);

  let {
    lenteContactoOjo,
    lenteContactoEsfera,
    lenteContactoCilindro,
    lenteContactoEje,
    lenteContactoCurvaBaseValor,
    lenteContactoDiametroValor,
    lenteContactoAdicion,
    lenteContactoProducto,
    lenteContactoProductoDescripcion,
    lenteContactoPresentacion,
    lenteContactoPresentacionDescripcion,
    lenteContactoPrecioVenta,
    lenteContactoPrecioVentaContado,
    lenteContactoCantidad,
    lenteContactoSubtotal,
    lenteContactoSubtotalContado,
    lenteContactoVentaPorUnidad,
  } = lenteContacto;

  const [lcProductos, setLcProductos] = useState([]);
  const [lcPresentaciones, setLcPresentaciones] = useState([]);
  //
  // ################################################################################
  //
  useEffect(() => {
    loadLcProductos();
    loadLcPresentaciones();
  }, []);
  //
  // ################################################################################
  //
  const loadLcProductos = async () => {
    const response = await getCacheData("lente_contacto_producto");
    if (response.ok) {
      setLcProductos(response.data.data);
    } else {
      setLcProductos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadLcPresentaciones = async () => {
    const response = await getCacheData("lc_presentacion");
    if (response.ok) {
      setLcPresentaciones(response.data.data);
    } else {
      setLcPresentaciones([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleClickOpenBuscarLPLenteContacto = () => {
    setOpenDialogBuscarLPLenteContacto(true);
  };
  //
  // ################################################################################
  //
  const handleCloseBuscarLPLenteContacto = (parCorreccion) => {
    setOpenDialogBuscarLPLenteContacto(false);

    if (!isEmptyObject(parCorreccion)) {
      // si el usuario seleccionó una lente de contacto de la lista de precios

      let _params = {
        tipoArticulo: "lente-contacto",
        id: parCorreccion.id_lente_contacto_producto,
      };

      const responseDescuento = getPorcentajeDescuento(_params);
      let _porcentajeDescuento = 0;
      if (responseDescuento.ok) {
        _porcentajeDescuento = responseDescuento.data.data.porcentaje_descuento;
      }
      let _precioVentaContado =
        parCorreccion.precio_venta_lista -
        (parCorreccion.precio_venta_lista * _porcentajeDescuento) / 100;

      const _lenteContactoPrecio = {
        lenteContactoProducto: parCorreccion.id_lente_contacto_producto,
        lenteContactoProductoDescripcion: parCorreccion.descripcion_lente_contacto_producto,
        lenteContactoProductoMultifocal: parCorreccion.multifocal_lente_contacto_producto,
        lenteContactoPresentacion: parCorreccion.id_lc_presentacion,
        lenteContactoPresentacionDescripcion: parCorreccion.descripcion_lc_presentacion,
        lenteContactoVentaPorUnidad: parCorreccion.venta_por_unidad === true ? "Unidad" : "Caja",
        lenteContactoEsfera: parCorreccion.esfera,
        lenteContactoCilindro: parCorreccion.cilindro,
        lenteContactoEje: parCorreccion.eje,
        lenteContactoCurvaBase: parCorreccion.id_lc_curva,
        lenteContactoCurvaBaseValor: parCorreccion.valor_lc_curva,
        lenteContactoDiametro: parCorreccion.id_lc_diametro,
        lenteContactoDiametroValor: parCorreccion.valor_lc_diametro,
        lenteContactoAdicion: parCorreccion.adicion,
        lenteContactoPrecioVenta: parCorreccion.precio_venta_lista,
        lenteContactoPrecioVentaOriginal: parCorreccion.precio_venta_lista,
        lenteContactoPorcentajeDescuento: _porcentajeDescuento,
        lenteContactoPrecioVentaContado: _precioVentaContado,
        lenteContactoCostoPesos: parCorreccion.costo_pesos,
        lenteContactoSubtotal:
          lenteContacto.lenteContactoCantidad * parCorreccion.precio_venta_lista,
        lenteContactoSubtotalContado: lenteContacto.lenteContactoCantidad * _precioVentaContado,
      };

      setLenteContacto({
        ...lenteContacto,
        ..._lenteContactoPrecio,
      });
      setDisabledDatosLenteContacto(false);
    }
  };
  //
  // ################################################################################
  //
  const handleBlur = (e) => {
    let _cantidad = e.target.value;
    _cantidad =
      _cantidad === "" || isNaN(_cantidad) || parseInt(+_cantidad) <= 0 ? 1 : parseInt(+_cantidad);
    let _subtotal = _cantidad * lenteContactoPrecioVenta;
    let _subtotalContado = _cantidad * lenteContactoPrecioVentaContado;
    setLenteContacto({
      ...lenteContacto,
      lenteContactoCantidad: _cantidad,
      lenteContactoSubtotal: _subtotal,
      lenteContactoSubtotalContado: _subtotalContado,
    });
  };
  //
  // ################################################################################
  //
  const handleClickGuardarLenteContacto = () => {

    let _lenteContactoDescripciones = {
      lenteContactoProductoDescripcion: lcProductos.find(
        (item) => item.id === lenteContactoProducto
      ).descripcion,
      lenteContactoPresentacionDescripcion: lcPresentaciones.find(
        (item) => item.id === lenteContactoPresentacion
      ).descripcion,
    };
    guardarLenteContacto(_lenteContactoDescripciones);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Box
        sx={{
          "& > :not(style)": {
            p: 2,
            m: 1,
          },
        }}
      >
        <Paper elevation={3} sx={{ m: 1, p: 2 }}>
          <Accordion
            expanded={expandedAccordionLenteContacto}
            disabled={disabledAccordionLenteContacto}
            onChange={() => setExpandedAccordionLenteContacto(!expandedAccordionLenteContacto)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="anteojo"
            >
              <Typography>Lente de Contacto</Typography>
            </AccordionSummary>

            <AccordionDetails sx={{ borderTop: "1px solid rgba(0, 0, 0, .125)" }}>
              <Grid container spacing={3}>
                {gaAction.cu !== "view" && (
                  <>
                    <Grid item xs={12} md={12}>
                      {/* boton busqueda de lentes de contacto */}

                      <Button
                        sx={{ mr: 1, mb: 1 }}
                        variant="contained"
                        onClick={handleClickOpenBuscarLPLenteContacto}
                        startIcon={<SavedSearchIcon />}
                      >
                        Búsqueda de lentes de Contacto
                      </Button>
                    </Grid>
                  </>
                )}

                {/* producto */}

                <Grid item xs={12} md={4}>
                  <TextField
                    sx={{ width: "100%" }}
                    id="lenteContactoProductoDescripcion"
                    label="Producto"
                    variant="outlined"
                    size="small"
                    name="lenteContactoProductoDescripcion"
                    value={lenteContactoProductoDescripcion}
                    disabled={true}
                  />
                </Grid>

                {/* presentacion */}

                <Grid item xs={12} md={4}>
                  <TextField
                    sx={{ width: "100%" }}
                    id="lenteContactoPresentacionDescripcion"
                    label="Presentación"
                    variant="outlined"
                    size="small"
                    name="lenteContactoPresentacionDescripcion"
                    value={lenteContactoPresentacionDescripcion}
                    disabled={true}
                  />
                </Grid>

                {/* venta por */}

                <Grid item xs={12} md={4}>
                  <TextField
                    sx={{ width: "100%" }}
                    id="lenteContactoVentaPorUnidad"
                    label="Venta por"
                    variant="outlined"
                    size="small"
                    name="lenteContactoVentaPorUnidad"
                    value={lenteContactoVentaPorUnidad}
                    disabled={true}
                  />
                </Grid>

                {/* esfera */}

                <Grid item xs={12} md={2} sx={{ textAlign: "center" }}>
                  <TextField
                    inputProps={{
                      style: { textAlign: "center" },
                      maxLength: 6,
                      type: "number",
                      step: 0.25,
                    }}
                    id="esfera"
                    size="small"
                    sx={{ width: "100%" }}
                    name="lenteContactoEsfera"
                    value={lenteContactoEsfera}
                    disabled={true}
                    label="Esfera"
                  />
                </Grid>

                {/* cilindro */}

                <Grid item xs={12} md={2} sx={{ textAlign: "center" }}>
                  <TextField
                    inputProps={{
                      style: { textAlign: "center" },
                      maxLength: 6,
                      type: "number",
                      step: 0.25,
                    }}
                    id="cilindro"
                    size="small"
                    sx={{ width: "100%" }}
                    name="lenteContactoCilindro"
                    value={lenteContactoCilindro}
                    disabled={true}
                    label="Cilindro"
                  />
                </Grid>

                {/* eje */}

                <Grid item xs={12} md={2} sx={{ textAlign: "center" }}>
                  <TextField
                    inputProps={{
                      style: { textAlign: "center" },
                      maxLength: 6,
                      type: "number",
                      step: 0.25,
                    }}
                    id="eje"
                    size="small"
                    sx={{ width: "100%" }}
                    name="lenteContactoEje"
                    value={lenteContactoEje}
                    disabled={true}
                    label="Eje"
                  />
                </Grid>

                {/* curva base */}

                <Grid item xs={12} md={2} sx={{ textAlign: "center" }}>
                  <TextField
                    inputProps={{
                      style: { textAlign: "center" },
                      maxLength: 6,
                      type: "number",
                      step: 0.25,
                    }}
                    id="eje"
                    size="small"
                    sx={{ width: "100%" }}
                    name="lenteContactoCurvaBaseValor"
                    value={lenteContactoCurvaBaseValor}
                    disabled={true}
                    label="Curva"
                  />
                </Grid>

                {/* diametro */}

                <Grid item xs={12} md={2} sx={{ textAlign: "center" }}>
                  <TextField
                    inputProps={{
                      style: { textAlign: "center" },
                      maxLength: 6,
                      type: "number",
                      step: 0.25,
                    }}
                    id="eje"
                    size="small"
                    sx={{ width: "100%" }}
                    name="lenteContactoDiametroValor"
                    value={lenteContactoDiametroValor}
                    disabled={true}
                    label="Diámetro"
                  />
                </Grid>

                {/* adicion */}

                {lenteContacto.lenteContactoProductoMultifocal === true && (
                  <Grid item xs={12} md={2} sx={{ textAlign: "center" }}>
                    <TextField
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      id="adicion"
                      size="small"
                      sx={{ width: "100%" }}
                      name="lenteContactoAdicion"
                      value={lenteContactoAdicion}
                      disabled={true}
                      label="Adición"
                    />
                  </Grid>
                )}

                {/* lc para ojo */}

                <Grid item xs={12} md={2}>

                  <FormControl
                    fullWidth
                    disabled={disabledDatosLenteContacto || gaAction.cu === "view"}
                  >
                    <InputLabel id="ojo-select-label">Lente para ojo ...</InputLabel>
                    <Select
                      labelId="ojo-select-label"
                      label="Lente de Contacto para ojo ..."
                      id="ojo-select"
                      name="lenteContactoOjo"
                      value={lenteContactoOjo}
                      size="small"
                      onChange={handleChangeLenteContacto}
                    >
                      {lenteContactoOjoOptions.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.descripcion}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* precio de lista */}

                <Grid item xs={12} md={2}>
                  <TextField
                    sx={{ width: "70%" }}
                    id="lenteContactoPrecioVenta"
                    inputProps={{ style: { textAlign: "right" } }}
                    label="Precio de lista"
                    variant="outlined"
                    size="small"
                    name="lenteContactoPrecioVenta"
                    value={lenteContactoPrecioVenta.toLocaleString(
                      settings.numericLocales.language,
                      settings.numericLocales.options
                    )}
                    disabled={true}
                  />
                </Grid>

                {/* precio de contado */}

                <Grid item xs={12} md={2}>
                  <TextField
                    sx={{ width: "70%" }}
                    id="lenteContactoPrecioVentaContado"
                    inputProps={{ style: { textAlign: "right" } }}
                    label="Precio de contado"
                    variant="outlined"
                    size="small"
                    name="lenteContactoPrecioVentaContado"
                    value={lenteContactoPrecioVentaContado.toLocaleString(
                      settings.numericLocales.language,
                      settings.numericLocales.options
                    )}
                    disabled={true}
                  />
                </Grid>

                {/* cantidad */}

                <Grid item xs={12} md={2}>
                  <TextField
                    sx={{ width: "40%" }}
                    id="lenteContactoCantidad"
                    inputProps={{ style: { textAlign: "right" } }}
                    label="Cantidad"
                    variant="outlined"
                    size="small"
                    name="lenteContactoCantidad"
                    value={lenteContactoCantidad}
                    onChange={handleChangeLenteContacto}
                    onBlur={handleBlur}
                    disabled={disabledDatosLenteContacto || gaAction.cu === "view"}
                  />
                </Grid>

                {/* subtotal de lista */}

                <Grid item xs={12} md={2}>
                  <TextField
                    sx={{ width: "70%" }}
                    id="lenteContactoSubtotal"
                    inputProps={{ style: { textAlign: "right" } }}
                    label="Sub Lista"
                    variant="outlined"
                    size="small"
                    name="lenteContactoSubtotal"
                    value={lenteContactoSubtotal.toLocaleString(
                      settings.numericLocales.language,
                      settings.numericLocales.options
                    )}
                    disabled={true}
                  />
                </Grid>

                {/* subtotal de contado */}

                <Grid item xs={12} md={2}>
                  <TextField
                    sx={{ width: "70%" }}
                    id="lenteContactoSubtotalContado"
                    inputProps={{ style: { textAlign: "right" } }}
                    label="Sub Contado"
                    variant="outlined"
                    size="small"
                    name="lenteContactoSubtotalContado"
                    value={lenteContactoSubtotalContado.toLocaleString(
                      settings.numericLocales.language,
                      settings.numericLocales.options
                    )}
                    disabled={true}
                  />
                </Grid>
              </Grid>

              <Box sx={{ p: 2 }}>
                {gaAction.cu !== "view" && (
                  <>
                    <Button
                      sx={{ mr: 1 }}
                      variant="contained"
                      onClick={handleClickGuardarLenteContacto}
                      startIcon={<Add />}
                      disabled={disabledDatosLenteContacto || lenteContactoOjo === ""}
                    >
                      {lenteContactoAction.cu === "new" ? "Agregar" : "Actualizar"} Lente de Contacto
                    </Button>
                  </>
                )}

                {/* boton cancelar */}

                <Button
                  sx={{ mr: 1 }}
                  variant="outlined"
                  onClick={limpiaLenteContacto}
                  startIcon={<CancelIcon />}
                >
                  {gaAction.cu !== "view" ? "Cancelar" : "Cerrar"}
                </Button>
              </Box>
            </AccordionDetails>
          </Accordion>
        </Paper>
      </Box>

      <LenteContactoTable />

      {/* >>>> Diálogo de búsqueda de precios de lentes de contacto */}

      {openDialogBuscarLPLenteContacto && (
        <BuscarLPLenteContactoDialog
          open={openDialogBuscarLPLenteContacto}
          onClose={handleCloseBuscarLPLenteContacto}
        />
      )}

      {showMessage && (
        <Message showMessage={showMessage} setShowMessage={setShowMessage} message={message} />
      )}
    </>
  );
};

export default LenteContacto;
